export default __webpack_public_path__ + "static/media/017-roller skate.d3a6aee8.svg";